export default "__VITE_ASSET__DpYRqfLV__"